import React from 'react';
import { Icon } from '@carta/ink';
import { StyledSideNavTwiddle } from './styles';

export interface SideNavTwiddleProps extends React.HTMLAttributes<HTMLSpanElement> {
  open?: boolean;
}

const SideNavTwiddle = (props: SideNavTwiddleProps) => {
  const { open, ...otherProps } = props;
  return (
    <StyledSideNavTwiddle open={open} {...otherProps}>
      <Icon type="forward" size="xs" aria-hidden="true" />
    </StyledSideNavTwiddle>
  );
};

SideNavTwiddle.displayName = 'SideNav.Twiddle';

export default SideNavTwiddle;
